module.exports = "/img/_/_/_/assets/images/creeper/book/common//33.jpg?b6525455f863c04f730cdb0a043dd5ac";